import * as React from "react";

export const CodeIconSvg = ({fill}) => (
    <svg width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" d="M0,0H24V24H0Z" />
        <path fill={fill} d="M9.4,16.6,4.8,12,9.4,7.4,8,6,2,12l6,6Zm5.2,0L19.2,12,14.6,7.4,16,6l6,6-6,6-1.4-1.4Z" />
    </svg>
);
